import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SendFilesUpload } from 'src/app/send-file/send-files.model';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit {
  @ViewChild('preview') private preview: HTMLElement;
  @Output() sendFileUploadData: EventEmitter<SendFilesUpload> =
    new EventEmitter();
  public base64File: any = '';
  public isFileUploaded: boolean = false;
  public fileName: string = '';

  constructor(private toasterService: ToastrService) {}

  ngOnInit(): void {}

  onFileDropped(event) {
    if (event) {
      this.checkFiles(event.target.files);
    }
  }

  imageChange(event) {
    this.checkFiles(event.target.files);
  }

  checkFiles(files) {
    this.fileName = files[0].name;
    if (files && files.length > 0 && files[0] && files[0].type) {
      if (files[0].type !== 'application/pdf') {
        this.toasterService.error(
          'Please upload file acceptable extension (.pdf) '
        );
        return;
      } else if (files.length > 1) {
        this.toasterService.error('Only One File/time');
        return;
      } else {
        this.readFiles(files);
      }
    }
  }

  drop(e) {
    e.preventDefault();
    this.checkFiles(e.dataTransfer.files);
  }

  allowDrop(e) {
    e.preventDefault();
  }

  readFiles(files) {
    const preview = document.getElementById('preview');
    const reader = new FileReader();
    reader.onload = (event) => {
      let fileReader = event.target as FileReader;
      const demo = JSON.parse(JSON.stringify(fileReader.result));
      const base64 = demo.split(',');
      this.base64File = base64[1];
      const div = document.createElement('div');
      const img = document.createElement('img');
      const h5 = document.createElement('h5');
      const btn = document.createElement('button');
      const btnSend = document.createElement('button');

      div.className =
        'd-flex justify-content-center align-items-center previewDiv';
      div.style.gap = '15px';

      img.src = '../../../assets/images/flags/pdf.png';
      img.width = 40;
      img.height = 40;

      h5.textContent = this.fileName;

      btn.textContent = 'Delete';
      btn.className = 'btn btn-danger';
      btn.addEventListener('click', () => {
        this.isFileUploaded = false;
        preview.removeChild(div);
        reader.readAsDataURL(null);
      });

      btnSend.textContent = 'Upload File';
      btnSend.className = 'btn btn-success';
      btnSend.addEventListener('click', () => {
        const sendData: SendFilesUpload = {
          fileData: this.base64File,
          fileName: this.fileName,
        };
        this.sendFileUploadData.emit(sendData);
        this.isFileUploaded = false;
        preview.removeChild(div);
        reader.readAsDataURL(null);
      });

      div.appendChild(img);
      div.appendChild(h5);
      div.appendChild(btn);
      div.appendChild(btnSend);

      this.isFileUploaded = true;
      preview.appendChild(div);
    };
    reader.readAsDataURL(files[0]);
  }
}
